import { render } from "./L_Top.vue?vue&type=template&id=7f4b47fa"
import script from "./L_Top.vue?vue&type=script&lang=js"
export * from "./L_Top.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__